import {
  AddIcon,
  ChevronDownIcon,
  ChevronUpIcon,
  DeleteIcon,
} from "@chakra-ui/icons";
import {
  Badge,
  Box,
  Flex,
  FormControl,
  IconButton,
  Input,
  VStack,
} from "@chakra-ui/react";
import React, { useState } from "react";
import MyAutocomplete from "./Autocomplete";

const MyComicRow = React.memo(
  ({
    index,
    comic,
    handleAddAfter,
    handleRemove,
    handleAddBefore,
    handleAddOrReplace,
    franchise,
    setStory,
    style,
    isLast,
    showOrder,
  }) => {
    const [storyValue, setStoryValue] = useState(comic.story || "");

    return (
      <Flex alignItems="center" pb="3" pr="3" style={style}>
        <Box pr="2">
          <Badge bg="gray.600" borderRadius="sm" fontSize="0.8em">
            {showOrder
              ? `${
                  comic.order % 1 !== 0
                    ? "#".repeat(Math.floor(Math.log10(comic.order) + 1))
                    : comic.order
                }`
              : index + 1}
          </Badge>
        </Box>
        {/* <Box>
          {!!comic && comic.thumbnail && (
            <Image
              src={comic.thumbnail}
              alt={comic.title}
              mx="3"
              style={{
                width: "30px",
                height: "50px",
              }}
            />
          )}
        </Box> */}
        <Box flex="1">
          {/* <MyComicAutoComplete
            franchise={franchise}
            comic={comic}
            index={index}
            handleAddOrReplace={handleAddOrReplace}
          /> */}
          <MyAutocomplete
            franchise={franchise}
            comic={comic}
            index={index}
            onSelectionChange={handleAddOrReplace}
          />
        </Box>
        <Box px="2">
          <FormControl>
            <Input
              htmlSize={4}
              placeholder="Story"
              type="text"
              name="story"
              maxLength={1}
              value={storyValue}
              onChange={(e) => {
                setStoryValue(e.target.value.toUpperCase());
              }}
              onBlur={() => setStory(index, storyValue, comic)}
            />
          </FormControl>
        </Box>
        <Box pl="2">
          <Flex>
            <VStack>
              <IconButton
                size="xs"
                aria-label="Add a row"
                disabled={index === 0}
                icon={
                  <>
                    <AddIcon />
                    <ChevronUpIcon />
                  </>
                }
                onClick={() => {
                  handleAddBefore(index);
                }}
                bg="gray.800"
                p="2"
                mx="2"
                color="white"
                _hover={{ bgColor: "gray.600" }}
              />
              <IconButton
                size="xs"
                aria-label="Add a row"
                disabled={isLast}
                icon={
                  <>
                    <AddIcon />
                    <ChevronDownIcon />
                  </>
                }
                onClick={() => {
                  handleAddAfter(index);
                }}
                bg="gray.800"
                p="2"
                mx="2"
                color="white"
                _hover={{ bgColor: "gray.600" }}
              />
            </VStack>
            <IconButton
              size={"sm"}
              aria-label="Clear search"
              icon={<DeleteIcon />}
              onClick={() => {
                handleRemove(index, comic.id, comic.order);
              }}
              bg="gray.800"
              m="2"
              color="white"
              _hover={{ bgColor: "gray.600" }}
            />
          </Flex>
        </Box>
      </Flex>
    );
  }
);

export default MyComicRow;
